export default __webpack_public_path__ + "static/media/choudhary.3cdb3975.jpg";